import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Events from './views/Events.vue';
import EditEvent from './views/EditEvent.vue';
import Result from './views/Result.vue';
import Help from './views/Help.vue';
import fb from '@/firebaseConfig';
import store from './store';
//import AddEditMembers from './views/members/AddEditMember.vue';
const AddEditMembers = () => import('./views/members/AddEditMember.vue');
//import ListMembers from '@/views/members/ListMembers.vue';
const ListMembers = () => import('@/views/members/ListMembers.vue');


Vue.use(Router);
// protects all by default
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/signout',
      name: 'signout',
      beforeEnter: (to, from, next) => {
        store.dispatch('userSignOut');
      },
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
    },
    {
      name: 'resultsingle',
      path: '/result/:eventId',
      component: Result,
      props: true,
    },
    {
      name: 'editevent',
      path: '/events/edit/:eventId',
      component: EditEvent,
      props: true,
    },
    {
      name: 'editmember',
      path: '/members/edit/:memberId',
      component: AddEditMembers,
      props: true,
    },
    {
      name: 'listmembers',
      path: '/members',
      component: ListMembers,
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        plainLayout: true, skipAuth: true,
      },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ]
});

router.beforeEach((to, from, next) => {
  const skipAuth = to.matched.some((record) => record.meta.skipAuth);
  const isAuthenticated = fb.auth.currentUser;
  if (!skipAuth && !isAuthenticated) {
    next('/login');
  } else {
    next();
  }
});

export default router;
